<template>
  <v-container class="mt-4" style="max-width: 900px;">
    <div class="text-center mb-6">
      <h1 class="text-h4 font-weight-bold" style="color: #1E3A5F;">Choose How to Begin</h1>
      <p class="text-subtitle-1 text--secondary mt-2">Pick the path that works best for you</p>
    </div>

    <v-row>
      <v-col cols="12" md="4">
        <v-card
          class="pa-5 text-center path-card"
          elevation="2"
          rounded="lg"
          height="100%"
          @click="nav('/AIUpload')"
          style="cursor: pointer;"
        >
          <v-icon size="48" color="#007AFF" class="mb-3">mdi-file-upload</v-icon>
          <div class="text-h6 font-weight-medium mb-2" style="color: #1E3A5F;">Upload Your Resume</div>
          <div class="text-body-2 text--secondary mb-4">
            Let AI extract your experience automatically.
          </div>
          <v-btn color="primary" outlined small @click.stop="nav('/AIUpload')">
            Upload
            <v-icon small right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card
          class="pa-5 text-center path-card"
          elevation="2"
          rounded="lg"
          height="100%"
          @click="nav('/Sage')"
          style="cursor: pointer;"
        >
          <v-icon size="48" color="#F59E0B" class="mb-3">mdi-microphone</v-icon>
          <div class="text-h6 font-weight-medium mb-2" style="color: #1E3A5F;">Talk to Sage AI</div>
          <div class="text-body-2 text--secondary mb-4">
            Tell Sage AI about your career in a natural conversation.
          </div>
          <v-btn color="primary" outlined small @click.stop="nav('/Sage')">
            Start Talking
            <v-icon small right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card
          class="pa-5 text-center path-card"
          elevation="2"
          rounded="lg"
          height="100%"
          @click="nav('/Information')"
          style="cursor: pointer;"
        >
          <v-icon size="48" color="#007AFF" class="mb-3">mdi-pencil</v-icon>
          <div class="text-h6 font-weight-medium mb-2" style="color: #1E3A5F;">Build Step by Step</div>
          <div class="text-body-2 text--secondary mb-4">
            Enter your information manually, section by section.
          </div>
          <v-btn color="primary" outlined small @click.stop="nav('/Information')">
            Start Building
            <v-icon small right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-card>
      </v-col>
    </v-row>

    <div class="text-center mt-8">
      <v-icon small color="grey" class="mr-1">mdi-information-outline</v-icon>
      <span class="text-body-2 text--secondary">
        Visit Career Profile anytime to see your progress and find gaps.
      </span>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Summary",
  methods: {
    nav(routerPath) {
      this.$router.push({ path: routerPath });
    },
  },
};
</script>

<style scoped>
.path-card:hover {
  border: 1px solid #007AFF;
  transition: border 0.2s ease;
}
</style>
